/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Turkish language
 *
 * @file tr-TR.js
 * @author Manimaran.S
 */

const trTR = {
  'popularChannelSlider.allChannels': 'Tüm Kanallar',
  'popularChannelSlider.recommended': 'Tavsiye edilen',
  'hero.myetextbook.link': 'kütüphane',
  'hero.myetextbook.text': 'Doğru başlık değil mi? E-Ders Kitabınıza Erişin',
  'hero.etextfeaturestitle': 'E-Ders kitabınızdaki çalışma materyallerini bulun',
  'hero.etextfeaturesdescription': 'E-Ders kitabınız, başarılı olmanıza yardımcı olmak için tasarlanmış çalışma materyalleriyle birlikte gelir. Bilgi kartları ve daha fazlası ile doğrudan e-Ders kitabınızdan çalışın.',
  'aichat.title1': 'Bu e-Ders Kitabı ile ilgili her konuda yapay zekâ destekli yardım alın.',
  'aichat.chatDesc1': 'Başlamak için bir soru yazın',
  'subscriptiontext.isSubscribed': 'Aboneliğinize dahil',
  'subscriptiontext.nonSubscriber': 'Tam erişim için yükseltin',
  'topicConatiner.otherHeader': 'İlgili videolar ve uygulamalar',
  'topicConatiner.exactLiteHeader': 'İlgili kavramlar ve uygulamalar',
  'moremenu.downloadApp': 'Uygulamayı indir',
  'moremenu.downloadAppAlreadyDownload': 'Uygulamayı başka bir cihaza indirmek ve otomatik olarak oturum açmak veya yüklediğin uygulamada güvenli bir şekilde oturum açmak için benzersiz QR kodunu kullanmak için %Click here% tıkla.',
  'moremenu.downloadAppNotDownload': 'Uygulamayı indirmek ve benzersiz QR kodunla güvenli bir şekilde oturum açmak için %Click here% tıkla',
  'channel.noBundletitle': 'Benzer ve diğer kurslarınız için Çalışma Hazırlığını kullanın',
  'onboard.studyPlan': 'Özel çalışma planı oluşturuldu!',
  'onboard.addCourseAnother': 'Bir başka kurs eklemek ister misin?',
  'onboard.purchase': 'Pearson e-Ders Kitabı satın almam gerekiyor',
  'onboard.addCourseWithoutEtext': 'Çalışma Hazırlığını kullanarak kurs ekleyin',
  'onboard.mayBeLater': 'Belki sonra',
  'onboard.aboutCourse': 'Bize kursunuz hakkında bilgi verin',
  'onboard.close': 'Kapat',
  'course.addTitle': 'Kurs ekle',
  'common.PURCHASE': 'Satın Al',
  'common.CLOSE': 'Kapat',
  'open': 'aç',
  'continue': 'Devam et',
  'yes': 'Evet',
  'no': 'Hayır',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Başarılı!',
  'courses.toc.PUBLISH_MESSAGE': 'Öğrenciler, bir dahaki sefer içeriği açtıklarında değişikliklerinizi görürler.',
  'errors.GENERIC_TITLE': 'Şu anda erişim hakkınız yok',
  'errors.GENERIC_DESC': 'Öncelikle, önbelleğinizi yenileyin veya temizleyin. Bu işe yaramazsa, Pearson destek birimi ile ',
  'errors.GENERIC_LINK': 'iletişime geçin.',
  'errors.GENERIC_CODE': 'Hata kodu: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Abonelik Bulunamadı',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Hesabınız bu başlığa erişimi içermiyor. Bu mesajı yanlışlıkla aldığınızı düşünüyorsanız, lütfen Pearson Teknik Destek ile iletişime geçin.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Abonelik Bulunamadı',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Aboneliğiniz e-Ders Kitabı’na erişimi içermiyor, ancak şu anda bir kredi kartı kullanarak abone olabilirsiniz.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Hesabım',
  'menu.helpCenter': 'Yardım merkezi',
  'menu.preferencesCenter': 'Tercihler Merkezi',
  'menu.CONTACT_SUPPORT': 'Desteğe Başvur',
  'menu.HELP_SUPPORT': 'Yardım & destek',
  'menu.FAQS': 'SSS',
  'menu.CHAT_WITH_SUPPORT': 'Destekle sohbet et',
  'menu.OTP_CODES': 'OTP kodları',
  'menu.LAUNCH_CODE': 'Kod kaydını aç',
  'menu.SEND_CODE': 'Yeni kodu kullanıcıya e-posta ile gönder',
  'menu.SEND_CODE_PHONE': 'Yeni kodu kullanıcıya kısa mesaj ile gönder',
  'menu.LEGAL': 'Yasal',
  'menu.PRIVACY_NOTICE': 'Gizlilik bildirimi',
  'menu.TITLE_INFO': 'Başlık bilgisi',
  'menu.PEARSON_ACCESSIBILITY': 'Pearson erişilebilirliği',
  'menu.DEVICE_WARNING_MESSAGE': '{deviceLimit} cihaz kaydedin. Ayda 1 değiştirin.',
  'menu.ACCESSIBILITY': 'Erişilebilirlik',
  'menu.ACCESSIBILITY_SUPPORT': 'Erişilebilirlik desteği',
  'menu.DEVICES': 'Son cihazlar',
  'menu.THIS_DEVICE': 'Bu cihaz',
  'menu.GET_THE_APP_DOWNLOAD': 'Mobil uygulamayı indir',
  'menu.MOJO_APP_INFO': 'Pearson+\'yı çevrimdışı kullanmak için, telefonunuzdan veya tabletinizden uygulama mağazasına gidin.',
  'menu.DEVICE_LABEL': 'Cihaz',
  'menu.DEVICE_DISCONNECT': 'Bağlantıyı kes',
  'menu.FOXIT': 'Foxit tarafından desteklenmektedir',
  'menu.TERMS_OF_USE': 'Kullanım şartları',
  'menu.SIGN_OUT': 'Oturumu Kapat',
  'menu.PRINT_PAGE': 'Sayfayı yazdır',
  'menu.COPY_RIGHT': 'Telif Hakkı © {year} Pearson Education, Inc. Tüm hakları saklıdır.',
  'print.FOOTER_MESSAGE': '{fullName}({email}) tarafından {currentDate} tarihinde basıldı.',
  'print.WATERMARK': 'Telif Hakkı © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Bu ay zaten değiştirme yaptın',
  'device.SWITCH_DEVICE': 'Mevcut cihaza geçilsin mi?',
  'device.SWITCH_ONCE': 'Ayda yalnızca bir kez geçiş yapabileceğin için bunu geri alamazsın.',
  'device.SEAT_TAKEN': 'Bu koltuk dolu',
  'device.DISCONNECT_DEVICE': 'Sadece 3 cihazdan giriş yapabilirsin. Bu cihazla devam etmek için başka bir cihazın bağlantısını kes.',
  'device.ALERT_TEXT': 'Unutmayın, cihazları yalnızca ayda bir kez değiştirebilirsiniz.',
  'device.DISCONNECT': 'Bağlantıyı kes',
  'device.CONTINUE': 'Devam et',
  'device.HEADER': 'Diğer tarayıcı oturumunuz sonlandırılsın mı?',
  'device.CLOSE': 'Ana sayfaya geri dön',
  'device.CODE': '{maskedEmail} adresine gönderdiğimiz kimlik doğrulama kodunu girerek buradan devam edin. Bu işe yaramıyor mu? spam klasörünüzü kontrol edin, {support} ekibiyle iletişime geçin veya {email} gönderin.',
  'device.TIMER': 'Buraya kodunuzu girmek için {time} süreniz var',
  'device.RESEND': '{resend}',
  'device.FAQ': 'SSS',
  'device.RESEND_NAME': 'Tekrar gönder',
  'device.NOTE': 'Pearson+’ı iş yerinde ve evde olduğu gibi 2 farklı yerde düzenli olarak kullanıyorsanız, işiniz bittiğinde mutlaka oturumunuzu kapatın. Ayrıca, Pearson+ mobil uygulamasını en fazla 2 cihazda kullanabilirsiniz. Daha fazla bilgi için {faq} bölümüne bakın.',
  'device.NOTE_HEADER': 'Bir dahaki sefere bunu yapmaktan kaçının',
  'device.CONTACT_SUPPORT': 'müşteri desteği',
  'device.CONTACT_EMAIL': 'e-postanızı güncelleyin',
  'device.INCORRECT': 'Yanlış—kodunuzu tekrar kontrol edin veya yeniden gönderin.',
  'device.MANY_ATTEMPTS': 'Çok fazla deneme yaptınız, kodu yeniden göndermeyi deneyin',
  'device.EXPIRED': 'Süreniz doldu, kodu yeniden göndermeyi deneyin',
  'device.ACCESS_HEADER': 'Giriş yaptınız!',
  'device.ACCESS_DESC': 'Oturumunuz doğrulandı. Hazır buradayken, şifrenizi güncellemek ister misiniz?',
  'device.ACCESS_CHANGE_PASSWORD': 'Şifreyi değiştir',
  'device.ACCESS_RESET_PASSWORD': 'Şifreyi sıfırla',
  'device.THREATONE_TITLE': 'Herşey yolunda mı?',
  'device.THREATONE_DESC': 'Hesabınızda bazı şüpheli etkinlikler tespit ediyoruz.',
  'device.THREATONE_DESC_TWO': 'Şifrenizi değiştirmeniz iyi olur.',
  'device.MAY_BE_LATER': 'Belki sonra',
  'device.OKAY': 'Tamam',
  'device.ACCOUNT_LOCK_DESC': 'Güvende tutmak için oturumunuzu kapatıyoruz. Hesabınızla ilişkili e-postaya bir şifre sıfırlama bağlantısı gönderdik.',
  'device.ACCOUNT_LOCK_TITLE': 'Hesabınızda bazı şüpheli etkinlikler fark ettik',
  'device.ACCOUNT_LOCK_TIMER': 'Şu kadar zamanda oturumunuz kapatılacak {time}',
  'navigation.PAGE': 'Sayfa',
  'launchcode.CREATEBY': 'Oluşturan:',
  'launchcode.sentvia': 'Şununla gönderildi:',
  'launchcode.CODEINLAST': 'Son 7 gün içindeki kodlar:',
  'launchcode.TIMESENT': 'Gönderilme saati:',
  'launchcode.ACCOUNTEMAIL': 'Hesap e-postası:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP Kodu Kaydı',
  'textmessage.TITLE': 'Telefon Numarasını girin',
  'textmessage.PHONE_NUMBER': 'Telefon Numarası',
  'textmessage.SEND_CODE': 'Kodu Gönder',
  'textmessage.INVALID_NUMBER': 'Geçersiz Telefon Numarası.',
  'textmessage.SUCCESS_MESSAGE': 'Kod gönderildi',
  'remove.title': 'Başlık kaldırılsın mı?',
  'remove.subTitle': 'Daha sonra istediğiniz zaman geri alabilirsiniz\\n— yeniden eklemek için aramayı kullanmanız yeterlidir.',
  'remove.buttonText': 'Kaldır',
  'search.searchPlaceHolderPPlus': 'ISBN, Başlık veya Yazara Göre Ara',
  'search.searchPlaceHolderEText': 'Kitaplığınızda arama yapın',
  'footer.downloadMobileApp': 'Mobil uygulamayı indir',
  'footer.termsOfUse': 'Kullanım şartları',
  'footer.privacy': 'Gizlilik',
  'footer.cookies': 'Çerezler',
  'footer.doNotSellMyPersonalInformation': 'Kişisel bilgilerimi satmayın',
  'footer.accessibility': 'Erişilebilirlik',
  'footer.patentNotice': 'Patent bildirimi',
  'footer.copyrights': 'Pearson, Tüm hakları saklıdır.',
  'hero.toc.defaultPlacehoder': '--- bir konu seçin ---',
  'hero.openEtextBookV1': 'e-Ders Kitabını Aç',
  'hero.heroHeading': '<span>{channel_title}</span>Çalıştığınız için',
  'hero.heroHeadingForBundleUser': 'Çalışma Hazırlığı',
  'hero.study.help': 'Çalışma yardımı alın',
  'hero.study.jumpBackIn': 'Geri dön',
  'hero.study.numOfUsers': 'Şu anda Kanalları kullanan <b>{num_of_users}</b> öğrenci var.',
  'hero.heroChannel.cardsHeading': 'Kaldığın yerden devam et',
  'hero.marketingcard1.copy.title': 'Videolarla öğrenin',
  'hero.marketingcard1.copy.description': 'Zor konuları açıklayan kısa videoları izleyin.',
  'hero.marketingcard2.copy.title': 'Problemlerle pratik yapın',
  'hero.marketingcard2.copy.description': 'Binlerce sınav benzeri soru ve video çözümleri ile sınavınıza hazırlanın.',
  'hero.marketingcard3.copy.title': 'Uzman yardımı alın',
  'hero.marketingcard3.copy.description': 'Sorularınızı gönderin ve konunun uzmanlarından yanıt alın.',
  'hero.popularTopics.heading': 'Bu kanaldaki diğer popüler konular',
  'hero.popularChannels.headingv1': 'Başka bir kurs mu alıyorsun?',
  'hero.popularChannels.descriptionv2': 'Popüler çalışma yardımı konularına göz atın.',
  'hero.practice': 'Alıştırma yap',
  'hero.herobook.mappedChannelHeading': 'Bu Kanalda önerilen çalışma yardımı',
  'libraryL2.myBooks': 'Kitaplarım',
  'libraryL2.archived': 'Arşivlendi',
  'libraryL2.back': 'Geri',
  'hero.practiceProblem': 'Alıştırma sorusu',
  'nativeAppBanner.drawer.title': 'Şununla aç...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+ Uygulaması',
  'nativeAppBanner.banner.title': 'Pearson+ uygulaması',
  'nativeAppBanner.banner.description': 'Hareket halindeyken öğrenin',
  'hero.promotionalcard.list1': 'Zor konuları açıklayan kısa videolar',
  'hero.promotionalcard.list2': 'Binlerce sınav benzeri soru',
  'hero.promotionalcard.list3': 'Konu uzmanlarından yanıtlar alın',
  'hero.studyandexamprep': 'Çalışma Hazırlığı',
  'hero.heroBook.sectionSubHeadingV1': 'Kursunuza özel video açıklamaları ve alıştırma soruları ile zor konuları çözün.',
  'hero.heroBook.sectionSubHeadingV2': 'Kursunuza özel kavram açıklamaları ve alıştırma soruları ile zor konuları çözün.',
  'hero.SeeAllStudyOptions': 'Tüm çalışma seçeneklerini görüntüle',
  'hero.herobook.mappedChannelHeadingV1': 'Önerilen videolar ve alıştırma soruları',
  'hero.popularTopics.headingV1': 'Diğer popüler konular',
  'hero.heroHeadingV1': 'İçin <span>{replace_value}</span>',
  'hero.learnmore': 'Daha fazla bilgi edin',
  'hero.eTextbook': 'e-Ders Kitabı',
  'hero.goToPage.label': 'Sayfaya git',
  'subscription.studyTitle': 'Çalışma Hazırlığı',
  'print.printAvailTitle': 'Bu sayfayı yazdırmak ister misiniz? Şu şekilde yapabilirsiniz:',
  'print.printAvailDesc': 'e-Ders Kitabınızda, sağ üstteki hesap simgesini seçin. Seçeneklerden “Sayfayı yazdır”ı ve ardından yazdırma ayarlarınızı seçin.',
  'print.printNotAvailTitle': 'Bu e-metin için yazdırma seçeneği etkinleştirilmemiştir.',
  'print.printNotAvailDesc': 'Çevrim dışı erişim kolaylığı için lütfen kitabınızı Pearson+ mobil uygulaması üzerinden indirin ve istediğiniz zaman, istediğiniz yerde ders çalışmanın esnekliğinin tadını çıkarın!',
  'hero.header.cta': 'Çalışma araçlarına git',
  'hero.header.ctav2': 'Çalışma Hazırlığını Açın',
  'hero.marketing.title': 'e-Ders Kitabınızı bulun',
  'hero.marketing.subTitle': 'Ses, flashcard’lar, notlar ve daha fazlasını içeren 2.000\'den fazla eDers Kitabı arasından seçim yap. 4 aylık dönem için ayda sadece 10,99 ABD doları.',
  'hero.popularchannels.desc': 'Bu en önemli konularda çalışma yardımı al',
  'hero.removecourse.title': 'Kurs Kontrol Panelinden kaldırılsın mı?',
  'hero.removecourse.description': '“Kurs ekle” seçeneğine tıklayarak bu kursu her zaman kontrol paneline geri ekleyebilirsin',
  'hero.removecourse.primaryCtaText': 'Kaldır',
  'hero.removecourse.secondaryCtaText': 'İptal Et',
  'hero.tableOfContents': 'İçindekiler',
  'hero.search': 'Ara',
  'hero.emptystate.cta': 'E-Ders Kitaplarını ara',
  'hero.watch_it_again': 'Tekrar izle',
  'hero.mondly.learnLang.title': 'Ücretsiz olarak yeni bir dil öğrenin',
  'hero.mondly.subTitle': 'Pearson e-Ders Kitabı kullanıcıları üç aylık ücretsiz Mondly by Pearson kazanıyor.',
  'hero.mondly.description': 'Çoğu dil öğrenme uygulaması yalnızca İngilizce üzerinden dil öğrenmenize izin verir. Ancak en iyisi ana diliniz üzerinden öğrenmektir, bu nedenle Mondly 41 dilimizden herhangi biriyle öğrenmenize imkan tanır.',
  'hero.mondly.startLearningCTA': 'Öğrenmeye başla',
  'hero.mondly.marketing.bestApp': 'En İyi Uygulama',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Yılın Uygulaması',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017 EMEA Birincisi',
  'hero.mondly.marketing.editorChoice': 'Editörün Seçimi',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Bir dil öğrenin',
  'header.menu.moreAtPearson': 'Daha fazlası Pearson\'da',
  'hero.subscriptionStatusTitle2': 'Pearson+ kaynaklarınız',
  'hero.startStudying': 'Çalışmaya başla',
  'onboard.studyMaterials': 'Konunuzu seçin, sizin için özelleştirilmiş çalışma materyalleri içeren bir pano oluşturalım.',
  'hero.myETextbooks': 'e-Ders Kitaplarım',
  'header.continueInTheApp': 'Uygulama ile devam et',
  'hero.learnTxt': 'Öğren',
  'hero.examPrepTxt': 'Sınava hazırlık',
  'hero.aITutorTxt': 'Yapay Zeka Eğitmeni',
  'AI.toolTip': 'E-Ders kitabınızdaki herhangi bir şey hakkında bana soru sorun',
  'hero.studyExamPrepAllYourCourses': 'Tüm kurslarınız için Çalışma Hazırlığı',
  'header.qrCode.subHeaderTxt': 'Mobil cihazınızda Pearson+ uygulamasında hızlı ve güvenli bir şekilde oturum açmak için bu QR kodunu kullanın.',
  'header.qrCode.dontHaveApp': 'Uygulamaya sahip değil misiniz?',
  'header.qrCode.footerTxt': 'Bu kodu taradığınızda App Store veya Google Play\'e yönlendirileceksiniz. Uygulama indirildikten sonra kodu tekrar tarayarak oturum açın.',
  'header.qrCode.errorMsg': 'QR kodu yüklenemedi. Kapatın ve tekrar deneyin.',
  'hero.yourETextbook': 'E-Ders Kitabınız',
  'onboard.addCourseWithEtextBundle': 'Çalışma Hazırlığını kullanarak kurs ekleyin',
  'onboard.disableTooltipText': 'Tüm Çalışma Hazırlığı kursları eklendi!',
  'subscriptionstatus.bundlecta': 'Çalışma Hazırlığına erişin',
  'subscriptionstatus.nonbundlecta': 'Çalışma Hazırlığına erişin',
  'channel.genericBundle': 'Diğer kurslarınızda yardımcı olması için Çalışma Hazırlığınızı kullanın',
  'channel.relatedBundle': 'Ayrıca, diğer kurslarınızda yardımcı olması için Çalışma Hazırlığınızı kullanın',
  'onboard.courseAdded': 'Kurs eklendi!',
  'hero.flashcards': 'Flashcard´lar',
  'relatedChannelCard.title': 'Bu ilgili kaynak ile öğreniminizi geliştirin',
  'relatedChannelCard.badgeText': 'İlgili Çalışma Hazırlığı',
  'sessionInactivity.title': 'Hala orada mısın?',
  'sessionInactivity.description': 'Oturumunuz bir işlem yapılmadığı için <b>%TIMER%</b> içinde zaman aşımına uğrayacaktır.<br/>Oturumunuzun açık kalmasını ister misiniz?',
  'sessionInactivity.keepMeSignIn': 'Oturumumu açık tut',
  'sessionInactivity.signOut': 'Oturumu Kapat',
  'sessionTimeout.title': 'Oturum zaman aşımına uğradı',
  'sessionTimeout.description': 'Oturumunuz bir işlem yapılmadığı için zaman aşımına uğradı.',
  'print.qrCode.header': 'Mobil cihazınızda Pearson+ uygulamasını açmak için bu QR kodunu kullanın.',
  'print.qrCode.footer': 'Bu kodu taradığınızda App Store veya Google Play\'e yönlendirileceksiniz. Uygulama yüklendikten sonra, başlığınızı indirmek ve erişmek için oturum açın.',
  'hero.nestest.title': 'Öğretmenlik sertifika sınavına hazırlanın',
  'hero.nestest.subTitle': 'Pearson+ kullanıcıları artık öğretmenlik sertifika sınavlarına hazırlanmak için ulusal müfredata uygun hazırlık kurslarına ve deneme sınavlarına erişebilirler.',
  'hero.channelAI.title': 'Yardıma mı ihtiyacınız var? Yapay zekâ eğitmeni size yardımcı olabilir.',
  'hero.channelAI.desc': 'Bir soru sorun ve adım adım ödev yardımı, çalışma önerileri ve daha fazlasını alın - ihtiyacınız olduğunda size özel yardım.',
  'hero.channelAI.action': 'Yapay Zeka Eğitmenine şimdi soru sor',
  'new': 'Yeni!',
  'hero.practice.numOfUsers': 'Bu bölümde <b>{practice_num_of_users}</b> kişi alıştırma yapıyor',
  'hero.practice.cta': 'Şimdi pratik yap',
  'hero.practice.title': 'Alıştırma sorusu',
  'diagnostics.errorMsg': 'Tanılama yüklenemedi. Kapatın ve tekrar deneyin.',
  'qrcode.title': 'İstediğiniz yerde çalışmaya başlayın',
  'qrcode.subtitle': 'Pearson+ mobil uygulamasıyla istediğiniz yerde, istediğiniz zaman öğrenin. Hemen indirin ve kesintisiz bir öğrenme deneyiminin keyfini çıkarın.',
  'qrcode.detailsv1': 'Pearson+ uygulamasıyla, bu QR kodunu kullanarak kaldığınız yerden devam edebilirsiniz. Nereye giderseniz gidin kitabınızı arayın, flashcartlarla çalışın, video dersleri izleyin ve daha fazlasını yapın.',
  'qrcode.detailsv2': 'Hızlı bir şekilde oturum açmak ve kaldığınız yerden devam etmek istediğinizde bu QR kodunu tarayın.',
  'qrcode.details': 'Pearson+ uygulamasıyla, bu QR kodunu kullanarak kaldığınız yerden devam edebilirsiniz.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Pearson+ mobil uygulamasıyla istediğiniz yerde, istediğiniz zaman öğrenin. Hemen indirin ve kesintisiz bir öğrenme deneyiminin keyfini çıkarın.',
  'install': 'Install',
  'header.menu.createCourse': 'Yeni ders',
  'header.dropdown.courses': 'Dersler',
  'header.dropdown.recentlyViewed': 'Son görüntülenenler',
  'header.dropdown.viewAll': 'Tüm dersleri gör',
  'aet.courseHeader.inviteStudents': 'Öğrencileri davet et',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Öğrencileri, aşağıdaki bağlantı adresini veya talimatları e-postanıza ya da ders programınıza kopyalayarak bu e-Ders Kitabına erişmeye davet edin.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Bağlantı adresi',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Bağlantıyı kopyala',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Bağlantı adresini içeren talimatlar',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Talimatları kopyala',
  'aet.courseHeader.inviteStudentModal.instructionIntro': '{courseName} için {bookTitle} adlı e-Ders Kitabına erişme zamanı geldi.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Hazır olduğunuzda, e-ders kitabınıza şu adresten erişebilirsiniz: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Mevcut Pearson hesabınızla oturum açmanız istenecektir. Pearson hesabınız yoksa, yeni bir hesap oluşturabilirsiniz.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Yardıma mı İhtiyacınız Var?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Başlangıç Tarih:',
  'aet.courseHeader.endDate': 'Bitiş tarih:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Öğrenci listesini yönet',
  'aet.home.managegradesync': 'Not senkronizasyonunu yönet',
  'aet.home.copycourse': 'Dersi kopyala',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': 'Mevcut',
  'aet.instructorCourse.tabs.past': 'Geçmiş',
  'aet.instructorCourse.tabs.courseSettings': 'Kurs ayarları',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Öğrenci listesini yönet',
  'aet.instructorCourse.currentCourses.title': 'Mevcut dersler',
  'aet.instructorCourse.pastCourses.title': 'Geçmiş dersler',
  'aet.instructorCourse.createOrCopy.title': 'Bir Pearson e-Ders Kitabı dersi oluşturun veya kopyalayın',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Başka bir eğitmenin dersini kopyala veya yeni bir ders oluştur',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Başka bir eğitmenin dersini kopyala',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Kopyalamak istediğiniz dersi bulmak için ders kodunu girin.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Ders Kodu',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Ders Kodunu girin',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Şunu aradınız',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Katalogdan yeni ders oluştur',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Başlık, yazar, ISBN veya konu anahtar kelimelerine göre arama yapın.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Ara...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Daha çok göster',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Daha az göster',
  'aet.instructorCourse.cancel': 'İptal Et',
  'aet.instructorCourse.loading': 'Yükleniyor...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Not senkronizasyonu',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Not senkronizasyonunu yönet',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Ders adı',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Başlıksız',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Bölüm adı',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Başlıksız',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Kurum',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Kurum zorunludur',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Sonuç bulunamadı',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'Ders başlangıç tarihi',
  'aet.instructorCourse.courseForm.endDateLabel': 'Ders bitiş tarihi',
  'aet.instructorCourse.courseForm.datePlaceholder': 'gün/ay/yıl',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Başkalarının bu dersi kopyalamasına izin ver',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Bu dersi kopyalamak isteyen eğitmenlerle bu kodu paylaşın',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Kodu kopyala',
  'aet.instructorCourse.courseForm.optionalSuffix': '(isteğe bağlı)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Formda doğrulama hataları var',
  'aet.instructorCourse.courseForm.submitContinue': 'Devam et',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Kaydediyor...',
  'aet.instructorCourse.courseForm.submitError': 'Dersinizi oluşturamadık. Lütfen tekrar deneyin.',
  'aet.instructorCourse.courseForm.submitEditError': 'Değişikliklerinizi kaydedemedik. Lütfen tekrar deneyin.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Değişiklikleri Kaydet',
  'aet.instructorCourse.courseForm.materialsHeader': 'Ders materyalleri',
  'aet.instructorCourse.courseForm.resolveError': 'Ders materyallerini yükleyemedik. Lütfen tekrar deneyin.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Son görüntülenen',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Son eklenenler',
  'aet.instructorCourse.coursesSort.aToZ': 'A\'dan Z\'ye',
  'aet.instructorCourse.coursesSort.zToA': 'Z\'den A\'ya',
  'aet.instructorCourse.manageRoster.column.name': 'İsim',
  'aet.instructorCourse.manageRoster.column.role': 'Rol',
  'aet.instructorCourse.manageRoster.column.email': 'e-posta',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Statü',
  'aet.instructorCourse.manageRoster.enrolledDate': '{date} Tarihinde kaydoldu',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': 'Öğrenci',
  'aet.instructorCourse.roster.role.ta': 'ÖA',
  'aet.instructorCourse.roster.role.instructor': 'Eğitmen',
  'aet.instructorCourse.roster.status.active': 'Aktif',
  'aet.instructorCourse.roster.status.inactive': 'Aktif değil',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Tüm üyeler',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktif öğrenciler',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Aktif olmayan öğrenciler',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Öğretim asistanı',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Eğitmen',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Yazar:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Ders oluşturma tarihi:',
  'aet.instructorCourse.noCoursesFound': 'Ders bulunamadı',
  'aet.instructorCourse.backButton': 'Geri',
  'aet.instructorCourse.selectCourse': 'Ders seç',
  'aet.home.linkedToLms': 'LMS ile bağlantılı',
  'aet.instructorCourse.courseForm.title.create': 'Ders oluştur',
  'aet.instructorCourse.courseForm.title.copy': 'Dersi kopyala',
  'aet.instructorCourse.courseForm.title.edit': 'Ders bilgisi',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Ödevler',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Ödev içeriği',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Ödev teslim tarihleri',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Vurgular ve notlar',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Vurgulama Rengi',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Metni not edin',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Paylaşılan durum',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Öğrenci listesi ve katılım',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Öğrenci isimleri',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'E-posta adresleri',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Kayıtlar',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Tamamlama ve içgörüler',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Ayarlar',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Kopyalanan bilgi',
  'aet.studentRoster.manageStudentRosterButton': 'Öğrenci listesini yönet',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Öğrencilerin ilerleme durumlarını dışa aktar',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Statü:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Kayıt:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rol:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '{studentName} Terfi edilsin mi?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Bu kişi, öğretim asistanı olarak bu sınıftaki tüm öğrencilerin ilerlemelerini ve performanslarını görebilecektir.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Ayrıca öğrencileri ve ödevleri yönetebilecekler, ancak sınıfı silemeyecekler.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Öğretim asistanına terfi ettir',
  'aet.home.manageRoster.searchPlaceholder': 'Öğrenci ara',
  'aet.home.manageRoster.inactivateButtonLabel': 'Aktif olmayan seçili öğrenciler',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Öğrenci listesi güncelleniyor. Bu birkaç dakika sürebilir.',
  'aet.home.courses.search.searchPlaceHolder': 'Derslerini ara',
  'aet.courses.emptyStateDescription': 'Aşağıdaki seçeneklerden birini seçerek kursunuzu oluşturmaya başlayın.',
  'nativePromoBanner.continueInBrowser': 'Tarayıcıyla devam et',
  'globalnav.tooltip.hideNavText': 'Navigasyonu gizle',
  'globalnav.tooltip.showNavText': 'Navigasyonu göster',
  'aet.syllabus.progressTitle': 'Açılıyor...',
  'aet.syllabus.progressDesc': 'Ders programını hazırlarken lütfen bekle.',
  'aet.syllabus.uploadInputLabel': 'Dosyaları sürükleyip bırakın veya tıklayarak yükleyin',
  'aet.syllabus.uploadSyllabusTabLabel': 'Ders programı yükle',
  'aet.syllabus.dateAdjusterTabLabel': 'Tarih ayarlayıcı',
  'aet.syllabus.addManuallyTabLabel': 'Ödevleri manuel olarak ekle',
  'aet.syllabus.addEditLaterText': 'Ödevleri daha sonra da ekleyebilir ve düzenleyebilirsiniz.',
  'aet.syllabus.editAssignmentLabel': 'Ödevi düzenle',
  'aet.syllabus.addAssignmentLabel': 'Ödev ekle',
  'aet.syllabus.assignmentTitleLabel': 'Ödev Başlığı',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Son Tarih',
  'aet.syllabus.editDueDateLabel': 'Son tarihi düzenle',
  'aet.syllabus.chaptersCoveredLabel': 'Çalışılacak bölümleri veya kısımları seçin.',
  'aet.syllabus.updateCtaLabel': 'Ödevi güncelle',
  'aet.syllabus.addCtaLabel': 'Ödev ekle',
  'aet.syllabus.uploadLabel': 'Yükle',
  'aet.syllabus.confirmLabel': 'Onayla',
  'aet.syllabus.addContentLabel': 'İçerik ekle',
  'aet.syllabus.addEditContentLabel': 'İçerik ekle/düzenle',
  'aet.syllabus.notPublishedLabel': 'Yayınlanmadı',
  'aet.syllabus.updateDatesLabel': 'Tarihi güncelle',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Son teslim tarihiniz güncellendi. Kontrol edin, ardından yayınlayın.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Bölüm/alt bölüm bilgileriniz güncellendi. Lütfen gözden geçirin ve ardından yayınlayın.',
  'aet.syllabus.unassignedCoverageStatus': 'Bazı bölümler henüz atanmamıştır. Yayınlamadan önce bunları atayın.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Ödev silinsin mi?',
  'aet.deleteAssignmentTitleMultiple': 'Ödevler silinsin mi?',
  'aet.deleteAssignmentWarning': 'Bu işlem geri alınamaz ve ilgili tüm gönderimler ve öğrenci verileri artık görüntülenemez.',
  'aet.deleteAssignmentKeepCTA': 'Ödevi tut',
  'aet.deleteAssignmentDeleteCTA': 'SİL',
  'aet.assignments.loadingAsset': 'Öğe yükleniyor...',
  'aet.assignments.addToDate': 'Tarihe ekle',
  'aet.assignments.previewAsStudent': 'Öğrenci olarak önizleme',
  'aet.assignments.questionsAndTopics': 'Sorular ve konular',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Bitti',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Son Tarih',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Toplam soru',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': '{total} sorudan {count}. soru',
  'aet.assignments.publishToStudents': 'Öğrencilere yayımla',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Tarih ekle',
  'aet.doneLabel': 'Bitti',
  'aet.assignments.dueDateLabel': 'Ödev teslim tarihi',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': 'Manuel kurulum',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Gerçek zamanlı içgörülerden yararlanarak öğrenme eksikliklerini tespit edin; böylece geç kalmadan güvenle harekete geçebilirsiniz',
  'aet.onboarding.promotion.feature.3': 'Öğrenciler, hedef odaklı geri bildirimler ve entegre Pearson yapay zekâsı sayesinde daha fazla destek alıyor',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': 'Bu hafta yapılması gereken bir ödev yok.',
  'aet.assignments.progressTitle': 'İlerleme',
  'aet.assignments.performanceTitle': 'Güven',
  'aet.assignments.completionTitle': 'Tamamlama',
  'aet.assignments.statusTitle': 'Statü',
  'aet.assignments.addTooltip': 'Ödev ekle',
  'aet.assignments.deleteTooltip': 'Seçili ödevleri sil',
  'aet.assignments.selectToDeleteLabel': 'Seçme ve silme modu',
  'aet.assignments.bulkEditTooltip': 'Ödevleri toplu olarak düzenle',
  'aet.assignments.title': 'Ödevler',
  'aet.assignments.assignmentTitle': 'Ödev',
  'aet.assignments.dueDate': 'Son Tarih',
  'aet.tabular.searchPlaceholder.assignments': 'Ödevleri ara',
  'aet.tabular.searchPlaceholder.students': 'Öğrencileri ara',
  'aet.tabular.searchPlaceholder.questions': 'Soruları ara',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Bir veya daha fazla öğrencinin tüm ödevleri için teslim tarihi uzatılmıştır',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Bir veya daha fazla öğrencinin bu ödev için teslim tarihi uzatılmıştır.',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Bir veya daha fazla öğrencinin ödev teslim tarihi uzatılmıştır. Bu ödevleri görmek için Bilgi simgesine bakın.',
  'aet.home.loading': 'Yükleniyor...',
  'aet.home.errorFetchingAssignments': 'Ödevleri yüklerken bir hata oluştu',
  'aet.home.dueThisWeekTitle': 'Bu hafta bitmesi gerekiyor',
  'aet.home.allCaughtUpTitle': 'Her şeyi tamamladınız!',
  'aet.home.allCaughtUpDescription': 'Bu hafta yapılması gereken bir ödev yok.',
  'aet.home.suggestedRemediationTitle': 'Çalışma Hazırlığı tarafından önerilen inceleme',
  'aet.home.noSuggestedRemediationTitle': 'Önerilen inceleme materyali yok',
  'aet.home.noSuggestedRemediationDescription': 'Bir sonraki ödevinizden sonra tekrar kontrol edin.',
  'aet.home.assignmentIncludesTitle': 'Ödev şunları içerir',
  'aet.home.sectionsLabel': 'Bölüm(ler)',
  'aet.home.questionsCount': '{count} sorular',
  'aet.home.dueLabel': 'Teslim tarihi: {dueDate}',
  'aet.home.due': 'Vakti geldi:',
  'aet.home.progressCompletedLabel': 'Tamamlandı',
  'aet.home.progressCompletedPastDueLabel': 'Vakti geçmiş olan ödev tamamlandı',
  'aet.home.progressInProgressLabel': 'İşlem devam ediyor',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Başlamadı',
  'aet.home.progressCountOfTotal': '{count} nin {total}',
  'aet.home.NotAttemptedLabel': 'Denenmedi',
  'aet.home.questionsTotalLabel': 'Toplam soru',
  'aet.home.progressCompletedOnTimeLabel': 'Vaktinde tamamlandı',
  'aet.home.segmentGreatLabel': 'Harika',
  'aet.home.segmentGettingThereLabel': 'Tamam',
  'aet.home.segmentNeedsReviewLabel': 'Çalışması gerekli',
  'aet.home.segmentOkayLabel': 'Tamam',
  'aet.home.editAssignmentTooltip': 'Ödevi düzenle',
  'aet.home.deleteAssignmentTooltip': 'Ödevi sil',
  'aet.home.viewDetailsButton': 'Detayları gör',
  'aet.home.viewAsStudentButton': 'Öğrenci olarak görüntüle',
  'aet.home.welcomeButtonText': 'Başla →',
  'aet.review.emptyStateTitle': 'İncelenecek bir şey yok',
  'aet.review.emptyStateDescription': 'Bir sonraki ödevinizden sonra tekrar kontrol edin.',
  'aet.dashboard.tabs.upNext': 'Sonraki',
  'aet.dashboard.tabs.welcome': 'Hoş geldiniz',
  'aet.dashboard.tabs.assignments': 'Ödevler',
  'aet.dashboard.tabs.review': 'İncele',
  'aet.dashboard.tabs.studentRoster': 'Öğrenciler',
  'aet.dashboard.classSchedule': 'Okul Programı:',
  'aet.syllabus.dueTimeLabel': 'Bitmesi gereken tarih',
  'hero.accessEducatorGuides': 'Eğitimci kılavuzlarına erişin',
  'aet.assignment.save': 'Kaydet',
  'aet.assignment.finish': 'Bitir',
  'aet.assignment.saveAndAdd': 'Kaydet ve başka bir tane ekle',
  'aet.assignment.delete': 'SİL',
  'aet.assignment.saveAndClose': 'Kaydet ve kapat',
  'aet.studentRoster.title': 'Öğrenciler',
  'aet.studentRoster.titlev1': 'Öğrenci',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Son tarihler',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standart',
  'aet.studentRoster.dueDateAdjustment.option.2': ' +2 gün',
  'aet.studentRoster.dueDateAdjustment.option.3': ' +3 gün',
  'aet.studentRoster.dueDateAdjustment.option.5': ' +5 gün',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 hafta',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 hafta',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Sınıfın son günü',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} ödev güncellendi',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Son teslim tarihi geçmiş ödevler otomatik olarak güncellenememiştir. Her birini düzenleyerek yeni bir teslim tarihi belirleyin.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Son tarihler güncellenemiyor',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Tüm ödevlerin teslim tarihi geçmiş ve otomatik olarak güncellenememiştir. Her birini düzenleyerek yeni bir teslim tarihi belirleyin.',
  'aet.bulkEdit.bulkSplitInstruction': 'Ödevlerinizi eşit olarak paylaştıracağız.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'İlk ödev teslim tarihi',
  'aet.bulkEdit.lastAssignmentDue': 'Son ödev teslim tarihi',
  'aet.bulkEdit.assignmentsDueDays': 'Ödevlerin teslim tarihlerinin hangi günler olmasını istersiniz?',
  'aet.bulkEdit.addEditLaterText': 'Ödevleri oluşturmak için yapay zekâ kullanıyoruz. Daha sonra istediğiniz zaman ödev ekleyebilir ve düzenleyebilirsiniz.',
  'aet.bulkEdit.monday': 'Pazartesi',
  'aet.bulkEdit.tuesday': 'Salı',
  'aet.bulkEdit.wednesday': 'Çarşamba',
  'aet.bulkEdit.thursday': 'Perşembe',
  'aet.bulkEdit.friday': 'Cuma',
  'aet.bulkEdit.saturday': 'Cumartesi',
  'aet.bulkEdit.sunday': 'Pazar',
  'aet.toast.assignmentCreated.title': 'Ödev oluşturuldu!',
  'aet.toast.assignmentCreated.single': 'Otomatik olarak {assignmentTitle} şeklinde adlandırıldı.',
  'aet.toast.assignmentCreated.multiple': '{count} ödevler oluşturuldu',
  'aet.toast.assignmentUpdated.title': 'Başarıyla güncellendi',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} güncellendi',
  'aet.toast.assignmentUpdated.multiple': '{count} ödev güncellendi',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': 'Öğrenciler çalışmaya başlayana kadar ödev içeriği düzenlenebilir.',
  'aet.toast.viewAssignment': 'Ödevi incele',
  'aet.toast.viewAssignments': 'Ödevleri incele',
  'aet.welcome.title': 'Pearson e-ders kitabınız artık LMS kursunuza bağlı.',
  'aet.welcome.LMSAccounTitle': 'Öngörüleri keşfedin',
  'aet.welcome.LMSAccounDescription': 'Sınıfınızın hangi konularda zorlandığını tam olarak görün',
  'aet.welcome.createAssignmentsTitle': 'Ödevler oluştur',
  'aet.welcome.createAssignmentsDescription': 'Bölümleri manuel olarak veya ders programınızı yükleyerek atayın.',
  'aet.welcome.progressViewTitle': 'LMS\'nizde performansı takip edin',
  'aet.welcome.progressViewDescription': 'LMS kursunuzda not senkronizasyonu ayarlarını seçin',
  'aet.assignmentDetails.noAssignmentFound': 'Ödev bulunamadı',
  'aet.assignments.loadingErrorTitle': 'Ödev şu anda yüklenemiyor',
  'aet.assignments.loadingErrorDescription': 'Sayfayı yenilemeyi deneyin veya daha sonra tekrar kontrol edin.',
  'aet.assignmentStudentDetails.noDataFound': 'Henüz veri yok',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Kayıt olan öğrenci yok',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Öğrenciler e-ders kitabını satın aldıklarında sınıfınıza katılacaklar.',
  'aet.home.editAssignmentTooltipDisabled': 'Düzenlenemez: öğrencinin çalışması devam ediyor',
  'aet.home.deleteAssignmentTooltipDisabled': 'Silinemez: öğrencinin çalışması devam ediyor',
  'aet.home.StudentDetails.questions': 'Sorular',
  'aet.home.StudentDetails.attempts': 'Denemeler',
  'aet.home.StudentDetails.comprehension': 'Güven',
  'hero.titleInfo.tooltip': 'Başlık bilgisi',
  'aet.home.publishAssignments': 'Tüm ödevleri yayınla',
  'aet.assignments.saveScheduleAsDraft': 'Programı taslak olarak kaydet',
  'aet.assignments.reviewBeforePublishAlert': 'Ödevlerinizi gözden geçirin, ardından öğrencilerin görebilmesi için yayınlayın.',
  'aet.assignments.copiedCoursePublishAlert': 'Kopyaladığınız ödevlere tarih ekleyin ve öğrencilerin görebilmesi için yayınlayın.',
  'aet.assignments.allSetPublishAlert': 'Her şey hazır mı? Ödevlerinizi yayınlayarak öğrencilerin görebilmesini sağlayın.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Bazı içerikler Pearson öğrenim materyalleri temel alınıp, yapay zekâ kullanılarak oluşturulmuştur. Pearson\'ın sonuçları doğrulamak için bir prosedürü olsa da, yaratıcı yapay zekâ yine de insanlar, yerler veya gerçekler hakkında yanlış bilgiler üretebilir.',
  'aet.home.bulkEditTitle': 'Ödevleri toplu olarak düzenle',
  'aet.home.bulkEditSubtitle': 'Ders programınızda değişikliklerinizi yapın, ardından buraya yeniden yükleyin. Ödevleriniz ve teslim tarihleriniz buna göre güncellenecektir.',
  'aet.home.createAssignmentTitle': 'Ödevler oluştur',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Başka bir ödevde yer alıyor',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Bazı bölümler başka bir ödevde yer almaktadır.',
  'aet.welcome.welcome.Title': 'Hoş geldiniz!',
  'aet.home.student.roaster.ProgressTitle': 'Toplam tamamlanma',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Öğrenciler ödevlerine başladığında tekrar kontrol edin.',
  'aet.home.whatDueThisWeekTitle': 'Bu hafta yapılması gerekenler şunlar',
  'aet.assignments.edit.errorTitle': '{count} ödevlerde hatalar var',
  'aet.assignments.edit.errorSubTitle': 'Hatalı ödevler yayınlanamaz. Hataları düzelt veya onlar olmadan yayınla.',
  'aet.assignments.edit.publishAnyway': 'Yine de yayınla',
  'aet.assignments.edit.editAssignments': 'Ödevleri düzenle',
  'aet.assignments.edit.validationInfoToolTip': 'Ödevi düzenleyerek hataları gider',
  'aet.assignments.error.assignmentCreated.title': 'Tüm ödevlerde hatalar var',
  'aet.assignments.error.assignmentCreated.description': 'Hatalı ödevler yayınlanamaz. Hataları düzelt veya farklı bir ders programı dene.',
  'aet.assignments.error.uploadSyllabus': 'Ders programı yükle',
  'aet.assignments.error.editAssignments': 'Ödevleri düzenle',
  'aet.mondly.title': 'Diller',
  'aet.studentRoster.errorState.title': 'Öğrenci listesi mevcut değil',
  'aet.studentRoster.errorState.description': 'Öğrenci listenizi yükleyemedik. Sayfayı yenilemeyi deneyin veya daha sonra tekrar kontrol edin.',
  'aet.assignments.sectionLabel': 'bölüm(ler)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'soru(lar)',
  'aet.assignments.assignmentsLabel': 'ödev(ler)',
  'aet.assignments.performanceProgressBar': 'Performans İlerleme Çubuğu',
  'aet.assignments.completionProgressBar': 'Tamamlanma İlerleme Çubuğu',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Bu ödevi silmek istediğine emin misin?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Bu ödevleri silmek istediğine emin misin?',
  'aet.home.nextAssignmentTitle': 'Sonraki Ödev',
  'aet.home.courseSettings': 'Kurs ayarları',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ e-Ders Kitabı kaynakları',
  'aet.home.etextbookInformation': 'e-Ders Kitabı bilgileri',
  'aet.multiple.deleteAssignmentKeepCTA': 'Ödevi (ödevleri) tut',
  'aet.syllabus.processingText.header': 'Sınıfınıza ödev verilen okumaları düzenliyoruz – bu sadece bir dakika sürecek.',
  'aet.syllabus.processingText.uploading': 'Belgeniz yükleniyor',
  'aet.syllabus.processingText.activating': 'Yapay zekâ bileşenleri etkinleştiriliyor',
  'aet.syllabus.processingText.extracting': 'Okuma ödevleri açılıyor',
  'aet.syllabus.processingText.mapping': 'Ders kitabı içeriği eşleniyor',
  'aet.syllabus.processingText.finishing': 'Bitiyor',
  'aet.syllabus.uploadErrorMessage': 'PDF veya .docx dosyanızın 10 MB altında olduğundan ve internet bağlantınızın sağlıklı olduğundan emin olun.',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Okuma ödevi bulunamadı',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Bu dosyadan okuma ödevlerini alamadık. Bunları manuel olarak ekleyebilirsiniz.',
  'aet.syllabus.uploadFailedRetryCTA': 'Yeniden dene',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Ders programınızda <qualities a syllabus should have for this to work> olup olmadığını bir kez daha kontrol edin ve tekrar deneyin ya da ödevleri manuel olarak oluşturmaya geçin.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Manuel oluşturma',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Bir şey ters gitti',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Ders programını yükleyip işleme alamadık.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Bağlantınızı kontrol edip tekrar deneyin ya da manuel atama oluşturmaya geçin.',
  'aet.syllabus.uploadModal.successTotal.title': 'İncelenmeye hazır',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'İncelenmeye hazır',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Ödevleri gözden geçirin',
  'aet.syllabus.selectChapterWithQuestions': 'Soru(lar) içeren bir bölüm seçin.',
  'preferenceSetting.subTitle': 'Bu ayarlar, bu kurstaki tüm öğrenciler için varsayılan ayarlar olacaktır.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Yapay Zekâ etkileşimleri',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Arama sonuçlarında Yapay Zekâ Çalışma Aracı ve Yapay Zekâ özetlerini etkinleştirin',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Bu kitapla ilgili Çalışma Hazırlığı kaynaklarını göster',
  'aet.syllabus.footer': 'Görev oluşturma, yapay zekâ ile desteklenmektedir.',
  'aet.dashboard.footerDialogDeatils': 'Pearson öğrenim materyallerine dayalı ödev soruları oluşturmak için üretken yapay zekâ kullanılmaktadır. Pearson, sonuçları doğrulamak için bir süreç uygulasa da, üretken yapay zekâ yine de kişiler, yerler veya gerçekler hakkında yanlış bilgiler üretebilir. Yapay zekâ, sağladığınız müfredat ve/veya programa göre içeriği ödevler halinde gruplandırmak için de kullanılır.',
  'aet.review.footer': 'Yapay Zekâ kullanılarak oluşturulmuştur',
  'aet.footerCard.dismiss': 'Atla',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Çalışma Hazırlığı, öğrencilere bu kursa özel videolar ve alıştırma problemleri sunarak öğrenmeyi destekleyen ek bir araçtır.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Erişim planında Çalışma Hazırlığı bulunmayan öğrencilerden, Çalışma Hazırlığı kaynaklarını kullanmaya devam etmek için abone olmaları istenebilir.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Çalışma Hazırlığını zaten satın almış olan öğrenciler bu ayardan etkilenmeyecektir.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Çalışma Hazırlığının faydaları hakkında daha fazla bilgi edinin',
  'aet.home.viewCourseId': 'Kurs kimliğini görüntüle',
  'aet.home.copy': 'Kopyala',
  'aet.home.copied': 'Kopyalandı',
  'aet.home.courseLabel': 'Kurs Kimliği:',
  'schoolInfoCard.addUniversity': 'Okul ekle',
  'schoolInfoCard.title': 'Okul bilgisi',
  'schoolInfoCard.titleV1': 'Bize kursunuz hakkında bilgi verin',
  'schoolInfoCard.cta': 'Başla',
  'schoolInfoCard.pickInstitution': 'Okul seç',
  'schoolInfoCard.addUniversityTitle': 'Okulunu ekle',
  'schoolInfoCard.addUniversitySubtitle': 'Okulunuzu ve kursunuzu bilmemiz, size en yararlı çalışma materyallerini önermemizi sağlar.',
  'schoolInfoCard.searchPlaceholder': 'Okulunuzu arayın...',
  'schoolInfoCard.skip': 'Bu adımı atla',
  'schoolInfoCard.nextStep': 'Sonraki adım',
  'schoolInfoCard.notInList': 'Okulum listede yok',
  'schoolInfoCard.noResults': 'Aramanızla eşleşen okul bulunamadı',
  'schoolInfoCard.noResultsHeading': 'Okulunuzu bulamıyor musunuz?',
  'schoolInfoCard.noResultsInstruction': 'Aşağıya tam adınızı girin',
  'schoolInfoCard.noResultsInputPlaceholder': 'Okul adı',
  'schoolInfoCard.addInstitutionLabel': 'Bu okulu ekle',
  'aet.assignments.assignmentTitlePlaceholder': 'Bir başlık gir',
  'aet.assignments.titleValidation.titleRequired': 'Ödev başlığı zorunludur.',
  'aet.assignments.titleValidation.titleTooLong': 'Ödev başlığı {0} karakterden fazla olamaz.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Ödev başlığında desteklenmeyen karakterler bulunmaktadır.',
  'aet.assignments.titleValidation.titleDuplicate': 'Bu ödev başlığı zaten mevcut',
  'aet.syllabus.timeZoneLabel': 'Saat dilimi',
  'aet.review.reviewReadingFromAssignments': 'Ödevden okumayı incele',
  'aet.assignments.chaptersLabel': 'bölüm(ler)',
  'menu.myAccount.subTitle': 'Kurumunuz burada yer almaktadır',
  'menu.myAccount.subTitleNotAvailable': 'Kurumu daha sonra istediğiniz zaman buraya ekleyebilirsiniz.',
  'schoolInfoCard.toastMessage': 'Üniversite kaydedildi',
  'aet.review.threeDotMenu.askAI': 'Yapay Zekâya Sor',
  'aet.home.suggestedRemediationSubtitle': 'Konularınızı iyice öğrenmek için ilgili videoları izleyin ve alıştırmalar yapın.',
  'aet.home.laggedQuestionLabel': 'İşaretlenmiş sorular',
  'aet.home.correctAnswer': 'Doğru yanıt',
  'aet.home.incorrectAnswer': 'En yaygın yanlış yanıt',
  'aet.home.behaviourTrendsLabel': 'Soruya ilişkin bilgiler',
  'aet.home.strugglingStudentsLabel': 'Zorlanan öğrenciler',
  'aet.home.patternsInStudensAiLabel': 'Öğrencilerin yapay zekâ kullanımındaki paternler',
  'aet.home.questionLabel': 'Soru',
  'aet.home.studentAskingSimilarQuestions': 'Benzer sorular soran öğrenciler',
  'aet.home.assignmentDifficultQuestions': 'Zor sorular',
  'aet.home.behaviorTrends': 'Soruya ilişkin bilgiler',
  'aet.home.behaviors': 'Performans göstergeleri',
  'aet.home.mostDifficultTopics': 'En zor sorular',
  'aet.home.commentsFromStudentLabel': 'Öğrencilerin yorumları',
  'aet.home.disregard': 'Dikkate alma',
  'aet.home.reportAsInaccurate': 'Yanlış olarak bildir',
  'aet.home.Flagged': 'İşaretli',
  'aet.home.reportQuestionTitle': 'Soruyu bildir',
  'aet.home.reportQuestionLabel': 'Bu yanıtta yanlış olan neydi?',
  'aet.home.showComments': 'Yorumları göster',
  'aet.home.studentReports': 'öğrenci raporları',
  'aet.home.placeholderText': 'Lütfen açıklayın...',
  'aet.home.reportQuestion.notRelevant': 'İlgili değil',
  'aet.home.reportQuestion.notCorrect': 'Doğru değil',
  'aet.home.reportQuestion.unsafe': 'Güvenli değil / zararlı',
  'aet.home.reportQuestion.somethingElse': 'Başka bir şey',
  'aet.home.StudentDetails.assistedByAI': 'Yapay Zekâ destekli',
  'aet.home.strugglingStudents.emptyStateTitle': 'Şu anda zorlanan öğrenci yok.',
  'aet.home.strugglingStudents.emptyStateDescription': 'Daha sonra tekrar kontrol edin.',
  'aet.home.overallStatus.excelling': 'Mükemmel',
  'aet.home.overallStatus.fallingBehind': 'Geride kalıyor',
  'aet.home.overallStatus.keepingUp': 'Takipte',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Sadece “Zor soruları” göster.',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Sadece “Zorlanan öğrencileri” göster',
  'aet.home.viewQuestionInAssignment': 'Ödevdeki soruya bak',
  'aet.home.insightRisk.incorrectFirstAttempts': 'İlk denemede yanlış',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Birden fazla yanlış deneme',
  'aet.home.insightRisk.lowConfidence': 'Güven düzeyi düşük',
  'aet.home.insightRisk.mediumConfidence': 'Güven düzeyi orta',
  'aet.home.insightRisk.lowEngagement': 'Düşük katılım',
  'aet.home.insightRisk.countOfStudents': '{count} öğrencinin {total} si',
  'aet.home.insightRisk.na': 'Yok',
  'aet.home.strugglingStudentsHereLabel': 'Öğrenciler bu konuda zorlanıyor',
  'aet.home.insightRisk.didNotAttempt': 'Denemedi',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS Entegrasyonu',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default trTR;
